import src from "IMAGE";
export default { src, width: 130, height: 103, blurWidth: 0, blurHeight: 0};
